module.exports = __webpack_public_path__ + "img/imgicon.65e23450.png";